// extracted by mini-css-extract-plugin
module.exports = {"box":"index_box_3p7vA","planViewWrap":"index_planViewWrap_2rtfw","detail":"index_detail_3Fo3j"};